export const MAX_RANGE_DATE = '2199-12-31'
